<template>
  <div class="order-bump-container" v-if="!form.deleted">
    <div class="counter">{{ counter }}</div>
    <div class="row">
      <div class="col-lg-6">
        <snow-select
          v-model="form.product_id"
          id="product-select"
          label="Produto do Order Bump"
          :options="productOptions"
          @input="setProduct"
        />
      </div>
      <div class="col-lg-6">
        <snow-select
          v-model="form.offer_id"
          id="offer-select"
          label="Oferta do Order Bump"
          :options="options"
          :disabled="!form.product_id"
          @input="setOffer"
          :loading="loading"
        />
      </div>
    </div>
    <snow-button text="excluir" class="bg-red" @click="removeItem(counter)" />
  </div>
</template>

<script>
import SnowSelect from "@/components/snow-ui/form/SnowSelect.vue";
import { mapState } from "vuex";
export default {
  components: {
    SnowSelect
  },
  props: {
    form: {
      type: Object,
      default: null
    },
    counter: {
      type: Number,
      default: 1
    },
    productId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      orderBumpProduct: null,
      options: [],
      loading: false
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    productOptions() {
      return [
        ...this.products.filter(
          p =>
            p.type_product == "online_course" &&
            p.status == "active" &&
            p.id != this.productId
        )
      ];
    }
  },
  methods: {
    setProduct(value) {
      if (value) {
        this.loading = true;
        this.$store
          .dispatch("offer/getForOrderBump", {
            product_id: value,
            limit: 100
          })
          .then(({ data: { results } }) => {
            this.options = results.filter(
              offer => offer.status === "active" && !offer.is_expired
            );
          })
          .finally(() => (this.loading = false));
      } else {
        this.form.order_bump = "";
        this.setOffer("");
      }

      this.form.product_name = this.products.find(p => p.id == value)?.name;
    },
    setOffer(value) {
      this.form.offer_name = this.options.find(o => o.id == value)?.name;
    },
    removeItem(item) {
      this.$emit("remove", item);
    }
  },
  mounted() {
    if (this.form.product_id) this.setProduct(this.form.product_id);
  }
};
</script>
<style lang="scss" scoped>
.order-bump-container {
  display: grid;
  gap: 16px;
  align-items: center;

  grid-template-areas:
    "counter button"
    "row row";
  grid-template-columns: 1fr auto;

  .counter {
    grid-area: counter;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--dark);
    border: 1px solid;
    border-radius: 50%;
    font-size: 12px;
    height: 18px;
    width: 18px;
  }

  .row {
    grid-area: row;
    gap: 16px;
  }

  .bg-red {
    grid-area: button;
  }

  @media (min-width: 993px) {
    grid-template-areas: "counter row button";
    grid-template-columns: auto 1fr auto;
    .row {
      gap: 0px;
    }
  }
}
</style>
